module.exports = __webpack_public_path__ + "img/item-image-locked.a4a2754d.svg";